import React, { useState } from "react";
import t from "../helpers/t";

type Props = {
  item: any;
  index: number;
  value: any;
  onRemoveHandler: (e: React.MouseEvent<HTMLSpanElement>, item: any, index: number) => void;
  id?: string;
  extraAmount?: boolean;
  onExtraAmountChange?: (e: React.ChangeEvent<HTMLInputElement>, item: any) => void | null;
  amountValue?: any;
  amountLabel?: string;
  disabled?: boolean;
  short?: boolean;
  contextMenu?: boolean;
  handleContextMenu?: (e: any) => void | null;
};

const ComboSelectItem = ({
  item,
  index,
  value,
  onRemoveHandler,
  id,
  extraAmount = false,
  onExtraAmountChange,
  amountValue = null,
  amountLabel = "",
  disabled = false,
  short = false,
  contextMenu = false,
  handleContextMenu,
}: Props) => {
  const [showInput, setShowInput] = useState(true);

  return (
    <>
      {!contextMenu ? (
        <>
          <li className="select2-selection__choice" title={value} key={index + "_select_" + value}>
            {!short && (
              <span
                className="select2-selection__choice__remove"
                role="presentation"
                onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
                  onRemoveHandler(e, item, index);
                }}
                style={{ float: "left" }}
              >
                ×
              </span>
            )}
            <span
              style={
                extraAmount
                  ? !short
                    ? { width: "60%", float: "left" }
                    : { float: "left" }
                  : { width: "100%" }
              }
            >
              {value}
            </span>
            {extraAmount && (
              <>
                {showInput === true && typeof onExtraAmountChange !== "undefined" ? (
                  <>
                    {!short ? (
                      <>
                        <label style={{ fontSize: "x-small", float: "left", paddingTop: "5px" }}>
                          {t("count_units")}
                        </label>
                        <input
                          style={{
                            maxWidth: "20%",
                            minWidth: "20px",
                            float: "left",
                            textAlign: "center",
                          }}
                          type="number"
                          onChange={(e) => onExtraAmountChange(e, item)}
                          value={amountValue}
                          disabled={disabled}
                        />
                      </>
                    ) : (
                      <>
                        <span style={{ paddingLeft: "5px" }}>({amountValue})</span>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <button style={{ fontSize: "x-small", float: "left", paddingTop: "5px" }}>
                      <span>{amountLabel}</span>
                    </button>
                  </>
                )}
              </>
            )}
          </li>
        </>
      ) : (
        <>
          <li
            className="select2-selection__choice"
            title={value}
            key={index + "_select_" + value}
            id={id}
            onContextMenu={handleContextMenu}
          >
            {!short && (
              <span
                className="select2-selection__choice__remove"
                role="presentation"
                onClick={(e) => {
                  onRemoveHandler(e, item, index);
                }}
                style={{ float: "left" }}
              >
                ×
              </span>
            )}
            <span
              style={
                extraAmount
                  ? !short
                    ? { width: "60%", float: "left" }
                    : { float: "left" }
                  : { width: "100%" }
              }
            >
              {value}
            </span>
            {extraAmount && (
              <>
                {showInput === true && typeof onExtraAmountChange !== "undefined" ? (
                  <>
                    {!short ? (
                      <>
                        <label style={{ fontSize: "x-small", float: "left", paddingTop: "5px" }}>
                          {t("count_units")}
                        </label>
                        <input
                          style={{
                            maxWidth: "20%",
                            minWidth: "20px",
                            float: "left",
                            textAlign: "center",
                          }}
                          type="number"
                          onChange={(e) => onExtraAmountChange(e, item)}
                          value={amountValue}
                          disabled={disabled}
                        />
                      </>
                    ) : (
                      <>
                        <span style={{ paddingLeft: "5px" }}>({amountValue})</span>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <button style={{ fontSize: "x-small", float: "left", paddingTop: "5px" }}>
                      <span>{amountLabel}</span>
                    </button>
                  </>
                )}
              </>
            )}
          </li>
        </>
      )}
    </>
  );
};

export default ComboSelectItem;
